import { render, staticRenderFns } from "./singleAuthentication.vue?vue&type=template&id=2a05a254&"
import script from "./singleAuthentication.vue?vue&type=script&lang=js&"
export * from "./singleAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/procure-web-seven-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a05a254')) {
      api.createRecord('2a05a254', component.options)
    } else {
      api.reload('2a05a254', component.options)
    }
    module.hot.accept("./singleAuthentication.vue?vue&type=template&id=2a05a254&", function () {
      api.rerender('2a05a254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/singleAuthentication.vue"
export default component.exports